<template>
  <div id="app" class="full">
    <router-view class="full"/>
  </div>
</template>
<script>
import './assets/shared.postcss'
export default {
  created () {
  }
}
</script>

<style>
</style>
